// Bounded diagnostics, no perpetual RAF and no graph scans. CPU timings exclude
// asynchronous GPU execution; browser audit records wall-frame intervals too.
export function installAtlasPerformance(renderer,graph) {
  let start=0,frames=[],processes=0,mutations=0;
  const begin=()=>{start=performance.now();};
  const end=()=>{frames.push(performance.now()-start);if(frames.length>240)frames.shift();};
  const process=()=>{processes++;},mutate=()=>{mutations++;};
  renderer.on("beforeRender",begin);renderer.on("afterRender",end);renderer.on("afterProcess",process);
  const events=["nodeAttributesUpdated","eachNodeAttributesUpdated","edgeAttributesUpdated","eachEdgeAttributesUpdated"];
  events.forEach(e=>graph.on(e,mutate));
  renderer.on("kill",()=>{events.forEach(e=>graph.off(e,mutate));renderer.off("beforeRender",begin);renderer.off("afterRender",end);renderer.off("afterProcess",process);});
  return {snapshot(){const a=[...frames].sort((a,b)=>a-b);return {renderCpuP50:a[Math.floor(a.length*.5)]||0,renderCpuP95:a[Math.floor(a.length*.95)]||0,processes,mutations};}};
}
